import { useMemo, useState } from 'react';
import type { ContentFolder } from 'services/folders/entities';
import { ROOT_ID } from './folderNavigation';
import { folderSearch } from './folderSearch';
import type { ContentWithFolder } from './folderSearch';

export function useLibrarySearch(rootFolder: ContentFolder, currentFolder: ContentFolder, selectFolder: (id: string) => void) {
  const [searchTerm, setSearchTerm] = useState('');

  const isAtRoot = currentFolder === rootFolder;

  const { folders, contents } = useMemo((): { folders: ContentFolder[]; contents: ContentWithFolder[] } => {
    if (searchTerm === '') {
      return { folders: currentFolder.subfolders, contents: currentFolder.contents };
    }
    const searchRoot = isAtRoot ? rootFolder : currentFolder;
    return folderSearch(searchRoot, searchTerm);
  }, [rootFolder, currentFolder, searchTerm, isAtRoot]);

  const handleFolderSelect = (folderId: string | null) => {
    selectFolder(folderId ?? ROOT_ID);
    setSearchTerm('');
  };

  const isSearchEmpty = searchTerm !== '' && folders.length === 0 && contents.length === 0;

  return {
    searchTerm,
    setSearchTerm,
    folders,
    contents,
    handleFolderSelect,
    isAtRoot,
    isSearchEmpty,
  };
}
